import React, { useState } from 'react'
import moment from 'moment';
import { RadioButton  } from 'primereact/radiobutton';
import { useEffect } from 'react';
import Swal from 'sweetalert2';
const { $ } = window;
const ModalDiskonPO = ({listDiskon, onHandleClick, mode, onBrowseItems, listFreeDiskon, posisi, qty, show, closeModalDiskon}) => {
    const [state, setState] = useState({
        position: 1,
        item:[],
        selectedRow: {},
        _listDiskon: [],
        listFree: [],
        img_lampiran: '',
        max_qty: 0,
        data: {
            file: null,
            remark: '',
            value: null,
            mode: '',
            qty : 0
        }
    });
    

    const { position, item, selectedRow, _listDiskon, img_lampiran, data, listFree, max_qty } = state;

    useEffect(_ => {
        let idata = data;
        idata['mode'] = mode;
        setState({...state, position: posisi ? posisi : 1, mode : idata});
    },[])



    useEffect(_ =>{
        let arr_diskon = [];
        let idata = data;
        
        if(mode == 'header' || mode == 'free_item'){
            arr_diskon = listDiskon.filter(item => (item.item_mode == 'header' || item.item_mode == 'free_item' ));
        }else if( mode == 'detail'){
            arr_diskon = listDiskon.filter(item => (item.item_mode == 'detail' ));
        }
        const index = arr_diskon.findIndex(e => e.checked);
        idata['qty'] = qty;

        setState({...state, 
            _listDiskon: arr_diskon, 
            selectedRow: arr_diskon[index], 
            listFree: listFreeDiskon ,
            max_qty: qty,
            data: idata,
            position: posisi
        });
    },[listDiskon, mode, listFreeDiskon, qty, posisi])

    const onUsePromo = (item, data) => {
        if(parseInt(data.qty) > parseInt(max_qty)) {
            Swal.fire({
                icon: 'error',
                title: 'Promo Submit Failed',
                text: "Quantity applied is more than max quantity"
            });

            return;
        }
        onHandleClick(item, data);
    }

    const changePosition = (position, item) => {
        let idata = data;
        idata['value'] = item.value;
        idata['mode'] = position == 1 ? "" : item.item_mode;
        idata['remark'] = "";
        idata['file'] = null;
        setState({...state, position, item, data: idata, img_lampiran: ''});
    }

    const onChangeQty = (e, item) => {
        let idata = data;
        idata['value'] = e.target.value;
        setState({...state, data: idata});
    }

    const onChangeHandler=(e, row)=>{
        let filteredArray = [];
        filteredArray =  _listDiskon;
        const index = filteredArray.findIndex(e => e.discount_id == row.discount_id);
        if(index > -1) {
            filteredArray[index].checked = e.target.checked;
        }

        if(e.target.checked) {
            setState({...state, selectedRow: row, _listDiskon: filteredArray});
        }
    }

    const onChangeQtyModeDetail = (e) =>{
        let idata = data;
        idata['qty'] = e.target.value;
        setState({...state, data: idata});
    }
    
    const onImageChange = (e) => {
        const [file] = e.target.files;
        if (file) {
            let idata = data;
            idata['file'] = file;
            setState({ ...state, img_lampiran: URL.createObjectURL(e.target.files[0]), data: idata  });
        }
    }

    const onSelectImage = (i) => {
        $('#doc_'+ i).click();
    }
    
    const onChangeRemark = (e) => {
        let idata = data;
        idata['remark'] = e.target.value;
        setState({...state, data: idata});
    }

    useEffect(() => {
        if(show) {
            $("#modal-deduction").modal({backdrop: 'static', keyboard: false});
        }else{
            $("#modal-deduction").modal('hide');
        }
    }, [show]);
    
    return position == 1
    ? 
    <>
        <div className="modal-header">
            <h5 className="modal-title" style={{ fontWeight: '600' }}> Additional Deduction</h5>
            <button type="button" className="close"  data-dismiss="modal" aria-label="Close" onClick={closeModalDiskon} >
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div className='modal-body' style={{paddingLeft: 35,paddingRight: 35 }}>
           
            { _listDiskon && _listDiskon.length > 0 ?
                <>
                    {_listDiskon.map((row, index) => (
                        <div className='row' key={`promo-` + index}>
                            {/*<div className="col-sm-1">
                                <div className="radio radiofill radio-primary radio-inline">
                                    <label>
                                        <RadioButton value={row.paketid} name="radio" onChange={(e) => onChangeHandler(e, row)} checked={row.checked} disabled={true} />
                                        {<input type="radio" className='radio-helper' id="radio" name="radio" value={row.paketid} onChange={(e) => onChangeHandler(e, row)} /> }
                                    </label>
                                </div>
                            </div>*/}
                            <div className="col-sm-12">
                                <p style={{ marginBottom: 0 }}>{row.remark?.substring(0, 100)}... 
                                </p>
                                <p>
                                    <span style={{fontWeight: 500, cursor: 'pointer', textDecoration: 'underline'}} onClick={() => changePosition(2, row)}>Apply</span> 
                                </p>
                            </div>
                        </div>
                    ))}
                    
                    
                </>
                :
                <>
                Data Not Found
                </>
            } 
        </div>
    </>
    : 
    <>
        <div className="modal-header">
            <h5 className="modal-title" style={{ fontWeight: '600' }}><span className='fa fa-arrow-left' style={{cursor:'pointer'}} onClick={() => changePosition(1, item)}></span> &nbsp; Deduction Detail</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={closeModalDiskon}>
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div className="modal-body">
            <div className='row'>
                <div className="col-sm-8">
                    {item.discount}<br/>
                    {item.discount_id}
                </div>
                <div className="col-sm-4">
                    <p style={{marginBottom: 0}}>Approval</p>
                    <p style={{ fontWeight: 500 }}>{item.approval}</p>
                    {/* <p>{row.keterangan_paket}... <span style={{fontWeight: 500, cursor: 'pointer'}} onClick={() => changePosition(2)}>Lihat Detail</span> </p> */}
                </div>
            </div>
            <p>{item.remark}</p>
            <hr />
            <div className='col-sm-12'>
                <div className="form-group row">
                    <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">Value</label>
                    <div className="col-sm-10">
                        <input type="number" className="form-control" value={data.value} disabled={item.value != null} onChange={(e)=> onChangeQty(e, item)}  />
                    </div>
                </div>
            </div>
            <div className='col-sm-12'>
                <div className="form-group row">
                    <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">Remark</label>
                    <div className="col-sm-10">
                        <textarea maxLength={100} required={true} className='form-control' value={data.remark} rows={3} onChange={(e) => onChangeRemark(e)} >
                        </textarea>
                    </div>
                </div>
            </div>
            <div className='col-sm-12'>
                <label>Upload</label>
                <div>
                    <button  className="btn btn-modena" type="button" onClick={()=> onSelectImage(item.discount_id)}>
                        Choose File
                    </button>
                    <input type="file" id={`doc_${item.discount_id}`} accept="image/png, image/jpg, image/jpeg" className='d-none' onChange={(e) =>onImageChange(e)} />
                </div>
                <p>Supported formates : JPEG, PNG</p>
                { img_lampiran && 
                <div className='mb-4' >
                    <img src={img_lampiran} className='img-responsive' style={{ width: 160, height: 160 }} />
                </div>
                }
            </div>
            { data.mode == 'free_item' && 
                <>
                    <div className='col-sm-12 pb-2'>
                        <button  className="btn btn-modena" type="button" onClick={onBrowseItems} >
                            Select Items
                        </button>
                    </div>
                    
                    { listFree && listFree.length > 0 &&
                        <div className='col-sm-12'  style={{ backgroundColor: 'beige', padding: 10}}>
                            {listFree.map((row, index) => (
                                <p style={{marginBottom: 0}}>{index+1}. {row.itemname} x {row.qty}</p>
                            ))}
                        </div>
                    }
                    <hr />
                </>
            }
            { data.mode == 'detail' && 
                <div className='col-sm-12'>
                    <div className="form-group row">
                        <label htmlFor="inputEmail3" class="col-sm-2 col-form-label">Qty</label>
                        <div className="col-sm-10">
                            <input type="number" className="form-control" value={data.qty} onChange={(e)=> onChangeQtyModeDetail(e)} max={max_qty} min={1}  />
                        </div>
                    </div>
                </div>
            }
            <div className='row' style={{ justifyContent: 'flex-end' }}>
                <div className='col-sm-6'>
                    <button className="btn btn-modena btn-block" style={{ marginBottom: 30 }} type="button" onClick={()=> onUsePromo(item, data)}>
                        Use
                    </button>
                </div>

            </div>
        </div>
    </>
}

export default ModalDiskonPO